export default {
    created: "Template-ul WhatsApp a fost creat cu succes.",
    updated: "Template-ul WhatsApp a fost actualizat cu succes.",
    deleted: "Template-ul WhatsApp a fost sters cu succes.",
    restored: "Template-ul WhatsApp a fost restaurat cu succes.",
    synced_from_api: "Sincronizare cu API cu succes.",
}
